<div class="dialog-container">
    <div class="dialog-title-block"> 
        <h2>Edit User</h2> 
        <div class="flex-container gap-2">
            <div class="dialog-btn" (click)="onClose()">
                <img class="dialog-colse-btn" src="../../../assets/images/close.png" alt="close">
            </div>
        </div>
    </div>
    <form #f="ngForm" name="form" (ngSubmit)="f.form.valid && editUser(f.value)" novalidate>
        <div class="dialog-content-block p-4">
            <!-- <div class="form-group position-relative">
                <p class="text-start text-para text-grey-100 mb-3">Add users by entering the Full name, Username, Email and Role</p>
            </div> -->
            <div class="d-flex gap-5 w-100">
                <div class="w-50 d-flex flex-column">
                    <div class="form-group">
                        <h6 class="text-start text-heading-6 text-dark">First Name *</h6>
                        <input type="text" #first_name="ngModel" [(ngModel)]="userDetails.firstName" name="first_name" required>
                        <div class="form-error-msg">
                            <div *ngIf="f.submitted && first_name.errors?.required">First Name is required</div>
                        </div>
                    </div> 
                    <div class="form-group">
                        <h6 class="text-start text-heading-6 text-dark">Username *</h6>
                        <input type="text" #username="ngModel" [(ngModel)]="userDetails.userName" name="username" required>
                        <div class="form-error-msg">
                            <div *ngIf="f.submitted && username.errors?.required">Username is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <h6 class="text-start text-heading-6 text-dark">Email *</h6>
                        <input type="email" #email="ngModel" [(ngModel)]="userDetails.email" name="email" disabled>
                        <!-- <div class="form-error-msg">
                            <div *ngIf="f.submitted && email.errors?.required">Email is required</div>
                        </div> -->
                    </div>
                </div>
                <div class="w-50 d-flex flex-column">
                    <div class="form-group">
                        <h6 class="text-start text-heading-6 text-dark">Last Name *</h6>
                        <input type="text" #last_name="ngModel" [(ngModel)]="userDetails.lastName" name="last_name" required>
                        <div class="form-error-msg">
                            <div *ngIf="f.submitted && last_name.errors?.required">Last Name is required</div>
                        </div>
                    </div>
                    <div class="form-group position-relative">
                        <h6 class="text-start text-heading-6 text-dark">Role *</h6>
                        <div class="custom-input position-relative cursor-pointer" (click)="openRolesDropdown($event)">
                            <input type="hidden" #role="ngModel" [(ngModel)]="userDetails.roleId" name="role_id" required>
                            <p>{{ selectedRole !== "" ? selectedRole : "Select Role" }}</p>
                            <img class="position-absolute input-dropdown" src="../../../assets/images/dropdown.svg" alt="down_arrow" srcset="">

                            <div id="roles-dropdown" class="w-100 roles-dropdown position-absolute">
                                <ul *ngIf="roles.length !== 0">
                                    <li class="text-capitalize" *ngFor="let role of roles" (click)="onRoleChange(role)">{{ role.name }}</li>
                                </ul>
                                <ul *ngIf="roles.length === 0">
                                    <li>No Roles available</li>
                                </ul>
                            </div>
                        </div>
                        <div class="form-error-msg">
                            <div *ngIf="f.submitted && role.errors?.required">Role is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <h6 class="text-start text-heading-6 text-dark">Contact Number</h6>
                        <div class="custom-input">
                            <span class="me-2">{{ contactNumberCode }}</span>
                            <input class="input-no--style" type="text" #contact_number="ngModel" [(ngModel)]="userDetails.contactNumber" name="contact_number">
                        </div>
                        <div class="form-error-msg">
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group" *ngIf="isHardwarePermissions">
                <h6 class="text-start text-heading-6 text-dark">Stores *</h6>

                <div class="custom-input position-relative cursor-pointer" (click)="openStoresDropdown($event)">
                    <p *ngIf="selectedStores.length === 0">Select Stores</p>
                    <div *ngIf="selectedStores.length !== 0" class="d-flex flex-wrap align-items-center gap-2">
                        <div 
                            class="bg-grey-300 d-flex gap-3 justify-content-between align-items-center rounded-pill px-3 py-1"
                            *ngFor="let selectedStore of selectedStores"
                        >
                            <p class="text-para text-dark">{{ selectedStore.name }}</p>
                            <img class="close" src="../../../assets/images/remove.svg" alt="close" srcset="" (click)="onRemoveSelectStore(selectedStore.id)">
                        </div>
                        <!-- <div 
                            class="bg-grey-300 d-flex gap-3 justify-content-between align-items-center rounded-pill px-3 py-1"
                            *ngIf="selectedStores.length > 2"
                        >
                            <p class="text-para text-dark">+ {{ selectedStores.length - 2 }}</p>
                        </div> -->
                    </div>
                    <img class="position-absolute input-dropdown" src="../../../assets/images/dropdown.svg" alt="down_arrow" srcset="">
                    <div class="popup" id="stores-dropdown">
                        <div *ngIf="stores.length !== 0" class="form">
                            <div class="form-group py-2 app-border-grey--bottom">
                                <input name="store" id="all_store" type="checkbox" [(ngModel)]="isSelectAllStores" (change)="onSelectAllStores($event)">
                                <label for="all_store">All stores</label>
                            </div>
                            <div class="form-group" *ngFor="let store of stores">
                                <input name="store" [id]="store.name" type="checkbox" [value]="store.id" [checked]="isStoreSelected(store.id)" (change)="onSelectStores($event, store)">
                                <label class="text-capitalize" [for]="store.name">{{ store.name }}</label>
                            </div>
                        </div>
                        <div *ngIf="stores.length === 0">
                            <p class="text-para text-light-dark">No stores available/p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-error-msg">
                <div *ngIf="f.submitted && isHardwarePermissions && selectedStores.length === 0">Please select any one of store</div>
                <div *ngIf="f.submitted && serverErrorMsg !== ''">{{ serverErrorMsg }}</div>
            </div>
            <!-- <div class="form-group position-relative">
                <h6 class="text-start text-heading-6 text-dark">Default Store *</h6>
                <div class="custom-input position-relative cursor-pointer" (click)="openDefaultStoreDropdown($event)">
                    <input type="hidden" #role="ngModel" [(ngModel)]="userDetails.defaultStoreId" name="default_Store_id" required>
                    <p>{{ selectedDefaultStore !== "" ? selectedDefaultStore : "Select Default Store" }}</p>
                    <img class="position-absolute input-dropdown" src="../../../assets/images/dropdown.svg" alt="down_arrow" srcset="">

                    <div id="roles-dropdown" class="w-100 roles-dropdown position-absolute">
                        <ul *ngIf="stores.length !== 0">
                            <li class="text-capitalize" *ngFor="let role of roles" (click)="onDefaultStoreChange(defaultStore)">{{ defaultStore.name }}</li>
                        </ul>
                        <ul *ngIf="stores.length === 0">
                            <li>No Default Store available</li>
                        </ul>
                    </div>
                </div>
                <div class="form-error-msg">
                    <div *ngIf="f.submitted && default_store.errors?.required">Default Store is required</div>
                </div>
            </div> -->

            <div class="d-flex gap-5 w-100">
                <div class="w-50 d-flex flex-column">
                    <div class="form-group">
                        <input name="email_notification_enabled" id="email_notification_enabled" type="checkbox" value="N"  [(ngModel)]="userDetails.emailNotificationEnabledBool"   [checked]="userDetails.emailNotificationEnabled === 'Y'"
  (change)="userDetails.emailNotificationEnabled = $event.target.checked ? 'Y' : 'N'">
                        <label for="email_notification_enabled">Enable Email Notifications</label>
                    </div> 
                 </div>
            </div>
        </div>
        <div class="dialog-footer">
            <button class="px-4 py-2" type="button" (click)="onClose()">Cancel</button>
            <button class="px-5 py-2" type="submit">Edit</button>
        </div>
    </form>
</div>